import { waitForMs } from '../../../helpers';

export const showHideMenu = () => {
  // Menu (Desktop)
  $('button[data-dropdown-button]').on('click', function () {
    const targetId = $(this).data('target-menu');
    const targetMenu = $(`[data-id="${targetId}"]`);

    const isVisible = targetMenu.css('display');
    if (isVisible == 'none') {
      $('body').attr('header-menu-on', '');
      $(this).attr('on', '');
      targetMenu.show();
    } else {
      $('body').removeAttr('header-menu-on');
      $(this).removeAttr('on');
      targetMenu.hide();
    }

    if (targetId == 'academy-menu') {
      $('[data-id="enterprise-menu"]').hide();
      $('[data-target-menu="enterprise-menu"]').removeAttr('on');
    } else {
      $('[data-id="academy-menu"]').hide();
      $('[data-target-menu="academy-menu"]').removeAttr('on');
    }

    $('#amv2-button').removeAttr('on');
    $('.amv2').hide();
  });
};

export const showHideAcademyMenu = () => {
  $(document).on('click', '#amv2-button', async function () {
    const academyMenu = $('.amv2');

    if (academyMenu.css('display') == 'none') {
      $('body').attr('header-menu-on', '');
      $('#amv2-button').attr('on', '');
      academyMenu.css('display', 'flex');
      await waitForMs(10);
      academyMenu.addClass('show');
    } else {
      $('body').removeAttr('header-menu-on');
      $('#amv2-button').removeAttr('on');
      academyMenu.hide();
      academyMenu.removeClass('show');
    }

    $('[data-target-menu="enterprise-menu"]').removeAttr('on');
    $('.enterprise-menu').hide();
  });
};

export const hideAcademyMenu = () => {
  // Close Academy Menu V2 (Desktop)
  $(window).on('click', function (e) {
    const target = $(e.target);
    if (
      target.hasClass('amv2') ||
      target.hasClass('homepage-v3-topbar-xl__bottom') ||
      target.hasClass('homepage-v3-topbar-xl__bottom-inner') ||
      target.hasClass('homepage-v3-topbar-xl__navigations') ||
      target.hasClass('homepage-v3-topbar-xl-overlay')
    ) {
      $('body').removeAttr('header-menu-on');

      $('.amv2').hide();
      $('#amv2-button').removeAttr('on');

      $('.enterprise-menu').hide();
      $('[data-dropdown-button="enterprise"]').removeAttr('on');
    }
  });
};

export const loadAcademyMenu = () => {
  $.ajax({
    url: '/ui/Template@AcademyMenu',
    type: 'post',
    data: { lang: $('html').attr('lang') },
    async: true,
    success: function (data) {
      $('#wrapper-of-menus').append(data);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.log(JSON.stringify(jqXHR));
    },
  });
};

export const loadAcademyMenuV2 = () => {
  $.ajax({
    url: '/ui/Template@AcademyMenuV2',
    type: 'post',
    data: { lang: $('html').attr('lang'), page: $('#currentPage').val() },
    async: true,
    success: function (data) {
      $('#wrapper-of-menus').append(data);

      import('../../../../js/academy-menu-v2.js')
        .then()
        .catch(err => console.error(err));
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.log(JSON.stringify(jqXHR));
    },
  });
};

export const loadEnterpriseMenu = () => {
  $.ajax({
    url: '/ui/Template@EnterpriseMenu',
    type: 'post',
    data: { lang: $('html').attr('lang') },
    async: true,
    success: function (data) {
      $('#wrapper-of-menus').append(data);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.log(JSON.stringify(jqXHR));
    },
  });
};
